import { Fragment } from 'react'
import { useFormikContext } from 'formik'

import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import { REQUESTS_EDIT_DUE_DATE_FIELD_NAME } from '../RequestEditDueDateModal.constants'
import { getRequestEditDueDateEmptyValues } from '../RequestEditDueDateModal.utils'
import { RequestEditDueDateModalDateField } from '../RequestEditDueDateModalDateField'

function RequestEditStatusModalMassActionFields({
  actionTypes = Object.values(getEntityActionTypeSelectOptions()),
  typeSelectProps,
}) {
  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: getRequestEditDueDateEmptyValues(),
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...typeSelectProps,
          error: errors[REQUESTS_EDIT_DUE_DATE_FIELD_NAME],
          options: actionTypes,
        }}
      >
        <RequestEditDueDateModalDateField
          Container={Fragment}
          disabled={actionTypeValueIsRemoveAll}
          withoutDeadlineFieldName={null}
          withoutDeadlineLabel={null}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default RequestEditStatusModalMassActionFields
